(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const mainDetailsContainer = document.getElementById('Details-menu-drawer-container');
    const mainSummary = mainDetailsContainer?.querySelector('summary');
    if (!mainSummary) return;

    document.addEventListener('click', (event) => {
      if (event.target.closest('.menu-drawer__close-all-button')) {
        event.preventDefault();
        event.stopPropagation();
        mainSummary.click();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
